import {createPrivateRecipeFromSession,editPrivateRecipePlan} from './from-session.js';

function required(value,label,max=160){
  const text=String(value??'').trim();
  if(!text)throw new TypeError(label+' is required');
  if(text.length>max)throw new TypeError(label+' is too long');
  return text;
}

export function createPrivateRecipeService({
  journalRuntime,
  recipeCache,
  userId,
  now=()=>new Date().toISOString()
}={}){
  if(!journalRuntime?.sessionBundle)throw new TypeError('journalRuntime is required');
  if(!recipeCache?.get||!recipeCache?.put)throw new TypeError('recipeCache is required');
  const owner=required(userId,'userId',128);

  async function createFromSession(sessionId,{
    recipeId=null,
    title=null,
    description=null,
    locale='pl',
    idFactory,
    resolveWoodKey=null
  }={}){
    const bundle=await journalRuntime.sessionBundle(required(sessionId,'sessionId',128));
    if(!bundle)throw new Error('SMOKING_SESSION_NOT_FOUND');
    const result=createPrivateRecipeFromSession(bundle,{
      userId:owner,
      recipeId,
      title,
      description,
      locale,
      idFactory,
      resolveWoodKey,
      now
    });
    await recipeCache.put(result.plan,{cachedForUserId:owner});
    return result;
  }

  async function edit(recipeId,changes={}){
    const cached=await recipeCache.get(required(recipeId,'recipeId',128),{userId:owner});
    if(!cached)throw new Error('PRIVATE_RECIPE_NOT_FOUND');
    const updated=editPrivateRecipePlan(cached.plan,{...changes,updatedAt:changes.updatedAt||now()});
    await recipeCache.put(updated,{
      cachedForUserId:owner,
      guidance:cached.guidance||{}
    });
    return updated;
  }

  async function get(recipeId){
    const cached=await recipeCache.get(required(recipeId,'recipeId',128),{userId:owner});
    if(!cached||cached.plan.recipe.type!=='private')return null;
    return cached;
  }

  return Object.freeze({createFromSession,edit,get});
}
